import { useState, useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import userApi from '@api/userApi';
import userActions from '@state/user/actions';
import authProvider from '@utils/auth/createAuthProvider';

function useLoginForm() {

  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const rememberHandler = useCallback((remember) => {

    function beforeunloadEvent(event) {

      event.preventDefault();
      authProvider.logout();

    }

    if (remember) return window.removeEventListener('beforeunload', beforeunloadEvent);
    return window.addEventListener('beforeunload', beforeunloadEvent);

  }, []);

  const requestLogin = useCallback(
    (values) => {

      const { username, password, remember } = values;
      setLoading(true);
      setError(null);
      userApi
        .authCreate({ username, password })
        .then((response) => {

          setLoading(false);
          dispatch(userActions.userLogout());
          rememberHandler(remember);
          const {
            // eslint-disable-next-line max-len
            access_token: accessToken, token_type: tokenType, refresh_token: refreshToken, expires_in: expiresIn, user_data: userData,
          } = response;
          authProvider.login({
            accessToken, tokenType, refreshToken, expiresIn,
          }, userData, true);
          history.push('/');

        })
        .catch((resError) => {

          setLoading(false);
          const { status, friendlyErrorMessage } = resError;
          switch (status) {

            case 400:
              setError('Usuario y/o contraseña incorrectos');
              break;
            default:
              setError(friendlyErrorMessage);
              break;

          }

        });

    },
    [dispatch, rememberHandler, history],
  );

  useEffect(() => function CleanUp() {

    setLoading(false);

  });

  return { loading, requestLogin, error };

}

export default useLoginForm;
